import { useLocation, useParams } from "react-router-dom";
import WorkQComponent from "../components/work_queues/pages/WorkQComponent";
import { customWorkQSlugs } from "../components/work_queues/pages/custom/globalWorkQStructure";

export default function WorkQ() {
    let { workqSlug } = useParams();
    const location = useLocation();

    if (!workqSlug) {
        customWorkQSlugs.forEach((item) => {
            if (location.pathname.includes(item)) {
                workqSlug = item;
            }
        });
    }

    const remountKey = workqSlug || location.pathname;

    return <WorkQComponent key={remountKey} />;
}
